/*
 * @Author: Lin Yunhe
 * @Date: 2023-03-23 14:48:13
 * @LastEditors: Lin Yunhe
 * @LastEditTime: 2023-03-23 14:55:51
 */
import fetch from 'utils/fetch';

// 获取网站信息
export const getWebsiteInfo = () => {
    return fetch.get('/sunshine-purchase-server/common/website');
};
